// extracted by mini-css-extract-plugin
export default {"results":"quick-search_results__Z15xa","group":"quick-search_group__yeoID","count":"quick-search_count__DSABJ"};